import { parse } from 'query-string'
import { compose, lifecycle } from 'recompose'

import config from 'config'
import LoadingPage from 'layouts/LoadingPage'
import { page, setVideoSignupReferrer } from 'utils/trackingUtils'

export default compose(
  lifecycle({
    componentDidMount() {
      const { webstore_access_type } = parse(window.location.search)
      page('Video Webstore Referral Landing Page Viewed', {
        source: webstore_access_type,
      })

      if (webstore_access_type) {
        setVideoSignupReferrer({
          source: webstore_access_type,
          isWebstoreReferral: true,
          location: 'webstore-referrer',
        })
      }

      // Enforcing manual delay to allow LS value to be set
      setTimeout(() => {
        window.location.replace(config.DRIFT_VIDEO_EXTENSION_URL)
      }, 250)
    },
  })
)(LoadingPage)
